<template>
  <div id="content" class="pays-page">
      <!--提醒-->
    <div class='topDiv'>
        <div class="big-box">
            <img src="https://file.zuopin.cloud/mp_logo.svg" class='mp_logo' />
            <div class="pay-success-text">感谢选择云作品</div>
            <div class="pay-success-memo" @click="toHelp(76)">开具发票 > </div>
        </div>
    </div>
    <div class="bottomDiv">
      <div class="pay-success-btn" @click="toMiniApp">前往云作品小程序</div>   
    </div>
    <div style="clear: both;"></div>
  </div>
</template>

<script>

//cnpm install qrcodejs2 --save
import { obtain } from "@/request/api";
import { Message } from "element-ui";
import Axios from "axios";
import { toHelp,checkIsMiniApp } from "@/utils/common";

export default {
  name: "paySuccess",
  data() {
    return {
      tipShow: false,
      tipMessage: "",
      isWexin:false,
      isMobile:false,
      code_url:'',
      isSubmiting: false,
    };
  },
  mounted() {
    let that = this
    console.log('route', this.$route);
    
  },
  methods: {
    toHelp(id)
    {
      toHelp(id)
        
    },
    goBack() 
    {
      if(checkIsMiniApp())
      {
        wx.miniProgram.navigateBack()
      }
      else
      {
        window.history.go(-2);
      }
    },
    toMiniApp()
    {
      window.location.href = 'https://zuopin.cloud/home/wuik7ib787'
    }
  }
};
</script>

<style lang="less" scoped>
    html,
    body {
        height: 100%;
        margin: 0;
        padding: 0;
    }
    .pays-page
    {
      .topDiv{
          width:100vw;
          height: (calc(100vh));
          // height:calc(100vh - 94px);
          // background: red;
      }
      .big-box{
          position: relative;
          left: 0;
          top: calc(25vh);
          /* top: 50%;
          transform: translateY(-50%);*/
      }

      /* 针对桌面电脑 */
      @media screen and (min-width: 1024px) {
        .mp_logo {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 40px;
          display: block;
          height: 140px;
        }
      }
      
      /* 针对手机设备 */
      @media screen and (max-width: 1024px) {
        .mp_logo {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 40px;
          display: block;
          height: 140px;
        }
      }

      .pay-success-text {
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(0,0,0,1);
          text-align: center;
      }

      .pay-success-memo{
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFang SC;
          color: #0072FF;
          font-weight: 800;
          text-align: center;
          cursor: pointer;
      }

      .bottomDiv{
        position:absolute;
        z-index: 100;
        width:100vw;
        bottom: calc(20px + constant(safe-area-inset-bottom));
        bottom: calc(20px + env(safe-area-inset-bottom));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .pay-success-btn {
        font-size: 16px;
        text-align: center;
        color: #fff;
        background: #000;
        border-radius: 100px;
        width: 300px;
        height: 44px;
        line-height: 44px;
        z-index: 200;
        cursor: pointer;
        font-weight: 800;
      }

      .pay-success-btn:hover {
       opacity: 0.8;
      }

  }
  </style>